import { AccordionProps } from './accordion.types';
import React, { useState } from 'react';
import LanguageSpan from '../LanguageSpan';

const Accordion: (props: AccordionProps) => JSX.Element = ({
  className,
  title,
  iconActive,
  iconInactive,
  isActive,
  hierachy,
  children,
  onClick,
}) => {
  const [isAccActive, setIsAccActive] = useState(isActive);

  return (
    <div className={`accordion ${className ?? ''}`}>
      {React.createElement(
        `h${hierachy ?? 3}`,
        [],
        <button
          aria-expanded={isAccActive}
          className="title-acc"
          onClick={() => onClick?.() ?? setIsAccActive(!isAccActive)}
        >
          <span className="title-acc__icon-wrapper">
            <em
              className={
                isAccActive
                  ? iconInactive ?? 'icon-minus'
                  : iconActive ?? 'icon-plus'
              }
            />
          </span>
          <div className="accordion__content">
            <LanguageSpan
              text={title}
              keyPrefix={'title-acc__header'}
            ></LanguageSpan>
          </div>
        </button>
      )}
      <>{isAccActive ? children : ''}</>
    </div>
  );
};

export default Accordion;
